import styled, { keyframes } from 'styled-components'
import useOnlineStatus from '../../hooks/useOnlineStatus'

const slideDown = keyframes`
	from { transform: translateY(-100%); opacity: 0; }
	to   { transform: translateY(0);     opacity: 1; }
`

const Banner = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 9999;
	background: #c0392b;
	color: #fff;
	text-align: center;
	padding: 9px 16px;
	font-size: 0.82rem;
	font-weight: 500;
	letter-spacing: 0.01em;
	animation: ${slideDown} 0.3s ease;
`

const OfflineIndicator = () => {
	const isOnline = useOnlineStatus()

	if (isOnline) return null

	return <Banner>You're offline — previously viewed manuals and scriptures are still available.</Banner>
}

export default OfflineIndicator
